import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import { PresentationChartLineIcon } from "@heroicons/react/24/solid";
import OnlineDirectories from "./OnlineDirectories";

export const DigitalAssetsConfigTabs = [
  {
    to: ROUTE_PATHS.Utilities_DigitalAssets_OnlineDirectories_Index,
    icon: <PresentationChartLineIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Online Directories",
    component: OnlineDirectories,
    permission:
      PERMISSIONS.permission_utilities_digitalassets_onlinedirectories_view,
  },
];
